import ExcelJS from "exceljs"
import { saveAs } from "file-saver"

class Workbook extends ExcelJS.Workbook {
  download(filename) {
    this.xlsx.writeBuffer().then(function(data) {
      var blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
      saveAs(blob, filename)
    })
  }

  isEmpty() {
    return !this.SheetNames.length && JSON.stringify(this.Sheets === "{}")
  }
}

function boldRowText(row) {
  row.eachCell(function(cell, rowNumber) {
    cell.font = {
      bold: true
    }
  })
  return row
}

function setCellAlignment(row, colNum, position) {
  console.log(row)
  row.getCell(colNum).alignment = { vertical: "middle", horizontal: position }
  console.log(row)
  return row
}

export { Workbook, boldRowText, setCellAlignment }
